import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import './index.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="React Card Flipper by Factor1"
      meta={[
        { name: 'description', content: 'A React card flipper component (built with React 16.2.0) that can be triggered by hover or click.' },
      ]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
    <div style={{margin: '60px 0 0', textAlign: 'center'}}>
      <hr />
      <p>another open source project from the nice people at <a href="https://factor1studios.com">factor1</a></p>
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js